import { FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import { EMPTY_VALUE_PLACEHOLDER } from '~/app/_ui/shared/text-placeholders';
import DallasText from '~/app/_ui/Dallas/Text/DallasText';
import FormattedMiles from '~/app/_ui/shared/FormattedMeasurements/FormattedMiles';

type Props = {
  className?: string;
  load: FrontendLoad;
};

export default function DistanceCell({ className, load }: Props) {
  return (
    <DallasTableDataCell className={className}>
      {load.distance != null ? (
        <FormattedMiles textVariant="captionL" measurement={load.distance} />
      ) : (
        <DallasText variant="captionL">{EMPTY_VALUE_PLACEHOLDER}</DallasText>
      )}
    </DallasTableDataCell>
  );
}
